// extracted by mini-css-extract-plugin
export var active = "_ag-b";
export var activeIndicator = "_ag-6";
export var animate = "_ag-a";
export var disabled = "_ag-c";
export var flat = "_ag-1";
export var fullWidth = "_ag-3";
export var lg = "_ag-9";
export var md = "_ag-8";
export var redoButtonTabGroup = "_ag-0";
export var sm = "_ag-7";
export var tabButton = "_ag-4";
export var tabButtonsContainer = "_ag-2";
export var xs = "_ag-5";